import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ToastService {
  public toasts;
  constructor(public toastrService: ToastrService) { }

  show(textOrTpl: string, options: any = {}): any {
    this.toastrService.show(textOrTpl, options.screen, { enableHtml: true }, options.type);
  }

  showAndNavigate(textOrTpl: string, options: any = {}){
    return this.toastrService.show(textOrTpl, options.screen, { enableHtml: true }, options.type).onHidden;
  }

  showSuccess(message, title): any {
    this.toastrService.success(message, title);
  }

}
